window.HederaStickyHeaderCoordinatesBreadcrumbs = true;

theme.headerSticky = (function() {
  function ScrollSticky() {
    const header = document.querySelector('#shopify__header__section');
    const headerStickyTarget = document.querySelector('.header_bottom.header__sticky') || document.querySelector('.header__sticky');
    const announcementSection = document.querySelector('.hd-section-abar');
    const announcementBar = announcementSection ? announcementSection.querySelector('.hd-abar') : null;
    const breadcrumb = document.querySelector('[data-hd-breadcrumbs][data-hd-sticky="true"]');
    const breadcrumbShell = breadcrumb ? breadcrumb.closest('[data-hd-breadcrumbs-shell]') : null;

    if (!header || !headerStickyTarget) return;

    const stickyMode = header.dataset.hdStickyMode || 'up';
    const directionThreshold = Math.max(4, Number(header.dataset.hdStickyThreshold || 10));
    const desktopViewport = window.matchMedia('(min-width: 992px)');
    let headerHeight = 0;
    let announcementHeight = 0;
    let breadcrumbHeight = 0;
    let isSticky = false;
    let isHidden = false;
    let lastDirectionY = Math.max(0, window.scrollY || 0);
    let animationFrame = null;

    function isOverlayOpen() {
      return Boolean(document.querySelector('.hd-menu-drawer.is-open, .hd-menu-drawer.active, .offcanvas-header.active, .offcanvas-header.open, .predictive-search--search-template.active'));
    }

    function fixedAnnouncementHeight() {
      return desktopViewport.matches ? announcementHeight : 0;
    }

    function measureHeights() {
      if (!isSticky) headerHeight = headerStickyTarget.offsetHeight;
      announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
      breadcrumbHeight = breadcrumb ? Math.ceil(breadcrumb.getBoundingClientRect().height) : 0;

      document.documentElement.style.setProperty('--hd-sticky-announcement-height', announcementHeight + 'px');
      document.documentElement.style.setProperty('--hd-fixed-announcement-height', fixedAnnouncementHeight() + 'px');
      document.documentElement.style.setProperty('--hd-sticky-motion', (header.dataset.hdStickyDuration || 360) + 'ms');
      header.style.setProperty('--hd-sticky-header-height', headerHeight + 'px');
      if (breadcrumbShell) breadcrumbShell.style.setProperty('--hd-breadcrumb-height', breadcrumbHeight + 'px');
    }

    function updateBreadcrumb() {
      if (!breadcrumb || !breadcrumbShell) return;

      /* The one-pixel overlap prevents a page-colour seam between the two fixed bars. */
      const headerBottom = isSticky ? Math.max(0, Math.floor(fixedAnnouncementHeight() + headerHeight) - 1) : 0;
      breadcrumbShell.style.setProperty('--hd-breadcrumb-sticky-top', headerBottom + 'px');
      breadcrumbShell.classList.toggle('hd-breadcrumbs-shell--stuck', isSticky);
      breadcrumb.classList.toggle('hd-breadcrumbs--stuck', isSticky);
      breadcrumb.classList.toggle('hd-scroll-hidden', isHidden);
    }

    function setHidden(shouldHide) {
      const nextHidden = Boolean(shouldHide && !desktopViewport.matches && isSticky && stickyMode === 'up' && !isOverlayOpen());
      if (nextHidden === isHidden) return;

      isHidden = nextHidden;
      headerStickyTarget.classList.toggle('hd-scroll-hidden', isHidden);
      if (announcementBar) announcementBar.classList.toggle('hd-scroll-hidden', isHidden);
      updateBreadcrumb();
    }

    function setStickyState(shouldStick) {
      if (shouldStick === isSticky) return;

      isSticky = shouldStick;
      headerStickyTarget.classList.toggle('sticky', isSticky);
      header.classList.toggle('hd-sticky-space', isSticky);

      if (announcementSection && announcementBar) {
        announcementSection.classList.toggle('hd-announcement-space', isSticky);
        announcementBar.classList.toggle('hd-announcement-sticky', isSticky);
      }

      if (!isSticky) setHidden(false);
      updateBreadcrumb();
    }

    function update() {
      animationFrame = null;
      const currentY = Math.max(0, window.scrollY || 0);
      const stickyOrigin = announcementSection || header;
      const triggerTop = typeof TopOffset === 'function' ? TopOffset(stickyOrigin).top : 0;
      const shouldStick = currentY > triggerTop;

      setStickyState(shouldStick);

      if (!shouldStick || currentY <= triggerTop) {
        lastDirectionY = currentY;
        setHidden(false);
        updateBreadcrumb();
        return;
      }

      if (stickyMode === 'always' || isOverlayOpen()) {
        lastDirectionY = currentY;
        setHidden(false);
        updateBreadcrumb();
        return;
      }

      const movement = currentY - lastDirectionY;
      if (Math.abs(movement) >= directionThreshold) {
        setHidden(movement > 0);
        lastDirectionY = currentY;
      }
      updateBreadcrumb();
    }

    function scheduleUpdate() {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(update);
    }

    function refreshMeasurements() {
      measureHeights();
      scheduleUpdate();
    }

    measureHeights();
    update();

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', refreshMeasurements);
    desktopViewport.addEventListener('change', refreshMeasurements);
    document.addEventListener('shopify:section:load', refreshMeasurements);

    if (window.MutationObserver && document.body) {
      new MutationObserver(scheduleUpdate).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }
  }

  return ScrollSticky;
})();
